import React from 'react';

const MetaItem = ({ label, value }) => value ? (
  <div className="meta-item">
    <span className="meta-label overline">{label}</span>
    <span className="meta-value">{Array.isArray(value) ? value.join(', ') : value}</span>
  </div>
) : null;

export default MetaItem;
